
import { Observable } from 'rxjs';
import { Type } from '@angular/core';

export interface IDynamicComponent
{
    component: Type<any>;
    context$: Observable<any>;
}